<dx-splitter [orientation]="'horizontal'" class="flex flex-1 min-h-0">
  <dxi-splitter-item
    [template]="'palette'"
    [size]="140"
    [collapsible]="true"
    [resizable]="false"
  ></dxi-splitter-item>

  <dxi-splitter-item
    [template]="'editor'"
    [size]="'50%'"
    [minSize]="300"
    [resizable]="true"
    [collapsible]="false"
  ></dxi-splitter-item>

  <dxi-splitter-item
    [template]="'preview'"
    [minSize]="200"
    [resizable]="true"
    [collapsible]="true"
  ></dxi-splitter-item>

  <div
    *dxTemplate="let _ of 'palette'"
    class="flex flex-1 flex-col overflow-auto p-2"
  >
    <div
      class="flex min-h-10 flex-row items-center gap-2 pb-2 border-b border-slate-200 mb-2"
    >
      <i class="fa-light fa-puzzle-piece text-slate-600"></i>
      <span class="text-sm font-medium text-slate-700">{{
        "Componenti" | transloco
      }}</span>
    </div>

    <div class="grid grid-cols-3 gap-2 self-start">
      @for (item of designItems; track $index) {
        @if (item.divider) {
          <div class="text-xs col-span-3 border-b border-slate-200">
            <span class="text-slate-900">{{ item.title }}</span>
          </div>
        } @else {
          <dx-draggable
            [group]="'report-designer'"
            [data]="item"
            [clone]="true"
            (onDragStart)="onDragStart($event, $any(item))"
            (onDragMove)="onDragMove($event)"
            (onDragEnd)="onDragEnd($event)"
          >
            <div
              #target
              [sntTooltip]="item.title"
              [ngClass]="{
                'border border-slate-100': !item.extended,
                'border-2 border-slate-300 ': item.extended,
                'cursor-pointer': !item.canAdd || item.canAdd(template()),
                'cursor-not-allowed opacity-25':
                  readonly || (!!item.canAdd && !item.canAdd(template()))
              }"
              class="text-xs flex cursor-pointer flex-col items-center justify-center rounded-md bg-white px-2 py-2 shadow-sm transition-all hover:scale-105 hover:shadow-md"
            >
              <i class="{{ item?.icon }}"></i>

              @if (item.childTitle) {
                <span class="font-bold text-slate-900">
                  {{ item.childTitle }}
                </span>
              }
            </div>
          </dx-draggable>
        }
      }
    </div>
  </div>

  <div *dxTemplate="let _ of 'editor'" class="flex flex-1 flex-col min-h-0 m-2">
    <div
      class="flex min-h-10 shrink-0 flex-row items-center gap-2 pb-2 border-b border-slate-200 mb-2"
    >
      <i class="fa-light fa-pen-to-square text-slate-600"></i>
      <span class="text-sm font-medium text-slate-700">{{
        "Editor" | transloco
      }}</span>
    </div>

    <div class="relative flex-1 min-h-0">
      <div class="absolute inset-0 overflow-auto">
        <ng-container
          [ngTemplateOutlet]="itemsTemplate"
          [ngTemplateOutletContext]="{
            $implicit: template(),
            groupName: 'report-designer',
            groupTarget: 'template-drop-target',
            scrollable: false,
            cols: '1',
            level: 1
          }"
        ></ng-container>
      </div>
    </div>
  </div>

  <div
    *dxTemplate="let _ of 'preview'"
    class="flex flex-1 flex-col min-h-0 overflow-hidden m-2"
  >
    <div
      class="flex min-h-10 shrink-0 flex-row items-center justify-between gap-2 pb-2 border-b border-slate-200 mb-2"
    >
      <div class="flex flex-row items-center gap-2">
        <i class="fa-light fa-eye text-slate-600"></i>
        <span class="text-sm font-medium text-slate-700">{{
          "Anteprima" | transloco
        }}</span>
      </div>

      <dx-button-group
        keyExpr="type"
        [selectedItemKeys]="[previewType()]"
        [items]="[
          {
            type: 'soap',
            text: ('SOAP' | transloco),
            icon: 'fa-light fa-file-lines'
          },
          {
            type: 'pdf',
            text: ('PDF' | transloco),
            icon: 'fa-light fa-file-pdf'
          }
        ]"
        (onItemClick)="onPreviewTypeChange($event)"
      ></dx-button-group>
    </div>

    <div class="relative flex-1 min-h-0 overflow-auto">
      <div class="absolute inset-0 overflow-auto">
        <snt-report-designer-document-preview
          [templateConfig]="template()"
          [previewType]="previewType()"
        ></snt-report-designer-document-preview>
      </div>
    </div>
  </div>
</dx-splitter>

<ng-template
  #itemsTemplate
  let-template
  let-groupName="groupName"
  let-groupTarget="groupTarget"
  let-scrollable="scrollable"
  let-cols="cols"
  let-level="level"
  let-parentName="parentName"
  let-friendlyName="friendlyName"
  let-groupTitle="groupTitle"
  let-templateArrayOwner="templateArrayOwner"
  let-templateArrayKey="templateArrayKey"
>
  <div class="relative flex flex-1 flex-col">
    <div
      [ngClass]="{
        'border-transparent': currentDropTarget !== groupTarget,
        'border-slate-300': currentDropTarget === groupTarget
      }"
      class="
        absolute
        bg-slate-200
        rounded-md
        z-30
        flex
        items-center
        justify-center
        transition-all
        top-2
        border-2
        {{
        currentDropTarget === groupTarget ? 'opacity-50 inset-0' : 'opacity-0'
      }}"
    >
      <i
        class="fa-light fa-arrow-down-to-line fa-3x transition-opacity {{
          currentDropTarget === groupTarget ? 'opacity-100' : 'opacity-0'
        }}"
      ></i>
    </div>

    <dx-draggable
      [group]="groupName"
      [data]="{ templateItemsTarget: template, target: groupTarget }"
      class="{{
        scrollable ? 'absolute inset-0 overflow-auto' : 'flex flex-1 flex-col'
      }}"
      (onDragStart)="$event.cancel = true"
    >
      @if (template && template.length > 0) {
        <div class="flex-1 gap-2 grid grid-cols-{{ cols }}">
          @for (
            templateItem of template;
            track templateItem.config?.name ?? $index
          ) {
            <div
              [ngClass]="{
                'px-2': templateItem.hideIconsSection,
                'rounded-md border-2 border-slate-100':
                  templateItem?.type === 'group'
              }"
              class="group flex flex-col gap-2 bg-white"
            >
              <div
                (mouseenter)="onItemMouseEnter(templateItem, itemContentRef)"
                (mouseleave)="onItemMouseLeave(templateItem, itemContentRef)"
                class="flex flex-col px-1 py-1"
              >
                <!-- header -->
                @if (!templateItem.hideIconsSection) {
                  <div class="flex flex-row items-center gap-1">
                    <!-- icon -->
                    <div
                      class="flex w-7 items-center justify-center"
                      [class.opacity-25]="templateItem.config?.hidden"
                    >
                      <i
                        class="text-xl {{ templateItem?.icon }}"
                        [ngClass]="{
                          'text-slate-600':
                            currentDropTarget !== templateItem.config?.name,
                          'font-bold text-slate-900':
                            currentDropTarget === templateItem.config?.name
                        }"
                      ></i>
                    </div>

                    <!-- title -->
                    <div class="relative flex-1">
                      <span>&nbsp;</span>
                      <div
                        class="absolute inset-0 flex items-center justify-start overflow-hidden text-ellipsis whitespace-nowrap"
                      >
                        <span
                          class="uppercase transition-all"
                          [ngClass]="{
                            'text-sm text-slate-400':
                              currentDropTarget !== templateItem.config?.name,
                            'text-base font-bold text-slate-900':
                              currentDropTarget === templateItem.config?.name
                          }"
                          >{{ templateItem.title }}
                        </span>
                      </div>
                    </div>

                    <!-- actions -->
                    <div class="ml-auto flex flex-row items-center gap-2">
                      <div class="flex flex-row items-center gap-1">
                        @if (templateItem.config.quickview) {
                          <i class="fa-light fa-eye"></i>
                        }
                      </div>

                      <snt-button-icon
                        [disabled]="readonly"
                        [sntTooltip]="actionsTemplate"
                        [placement]="'left'"
                        icon="fa-light fa-ellipsis-stroke-vertical"
                      ></snt-button-icon>

                      <ng-template #actionsTemplate let-close="close">
                        <div class="flex flex-col gap-4">
                          <div class="flex flex-col gap-1">
                            <snt-button
                              icon="fa-light fa-up-to-line"
                              [title]="'Sposta in alto' | transloco"
                              [disabled]="readonly || $first"
                              (onClick)="
                                onSwapUp(
                                  template,
                                  $index,
                                  templateArrayOwner,
                                  templateArrayKey
                                );
                                close();
                                notifyTemplateChange()
                              "
                            ></snt-button>

                            <snt-button
                              icon="fa-light fa-down-to-line"
                              [title]="'Sposta in basso' | transloco"
                              [disabled]="readonly || $last"
                              (onClick)="
                                onSwapDown(
                                  template,
                                  $index,
                                  templateArrayOwner,
                                  templateArrayKey
                                );
                                close();
                                notifyTemplateChange()
                              "
                            ></snt-button>
                          </div>

                          @if (
                            "text,textarea,check,selectbox".indexOf(
                              templateItem?.type
                            ) >= 0
                          ) {
                            <div class="h-px bg-slate-100"></div>

                            <div class="ml-2 flex flex-row items-center gap-2">
                              <dx-switch
                                [value]="templateItem.config.quickview"
                                (valueChange)="
                                  templateItem.config.quickview = $event;
                                  notifyTemplateChange()
                                "
                                [disabled]="readonly"
                                [switchedOffText]="'No' | transloco"
                                [switchedOnText]="'Si' | transloco"
                              ></dx-switch>

                              <span class="text-base text-slate-900">{{
                                "Quickview" | transloco
                              }}</span>
                            </div>

                            <div class="h-px bg-slate-100"></div>
                          }

                          <snt-button
                            [disabled]="readonly || templateItem?.disableRemove"
                            icon="fa-light fa-trash"
                            (onClick)="onRemoveItem(template, templateItem)"
                            [title]="'Rimuovi' | transloco"
                          ></snt-button>
                        </div>
                      </ng-template>

                      @if (
                        templateItem.config.hidden ||
                        templateItem.disableSortable
                      ) {
                        <div
                          class="mt-auto flex flex-col items-center gap-2 rounded-md border border-solid border-slate-100 p-1"
                        >
                          @if (templateItem.config.hidden) {
                            <i class="fa-light fa-eye-slash opacity-25"></i>
                          }

                          @if (templateItem.disableSortable) {
                            <i class="fa-light fa-lock opacity-25"></i>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }

                <!-- content -->
                <div #itemContentRef class="flex flex-1 flex-col gap-2">
                  <div
                    class="relative flex"
                    [class.opacity-25]="templateItem.config.hidden"
                  >
                    @switch (templateItem?.type) {
                      @case ("custom") {
                        <snt-report-designer-custom
                          [item]="templateItem"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-custom>
                      }
                      @case ("tab") {
                        <snt-report-designer-tab
                          #renderer
                          [item]="templateItem"
                          [templateOutlet]="itemsTemplate"
                          [parentName]="parentName"
                          [level]="level"
                          [readonly]="readonly"
                          [disableRemoveWarning]="disableRemoveWarning"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-tab>
                      }
                      @case ("group") {
                        <snt-report-designer-group-vertical
                          #renderer
                          [item]="templateItem"
                          [templateOutlet]="itemsTemplate"
                          [level]="level"
                          [parentName]="parentName"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-group-vertical>
                      }
                      @case ("group-vertical") {
                        <snt-report-designer-group-vertical
                          #renderer
                          [item]="templateItem"
                          [templateOutlet]="itemsTemplate"
                          [level]="level"
                          [parentName]="parentName"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-group-vertical>
                      }
                      @case ("group-horizontal") {
                        <snt-report-designer-group-horizontal
                          #renderer
                          [item]="templateItem"
                          [templateOutlet]="itemsTemplate"
                          [level]="level"
                          [parentName]="parentName"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-group-horizontal>
                      }
                      @case ("image") {
                        <snt-report-designer-image
                          #renderer
                          [item]="templateItem"
                          [level]="level"
                          [parentName]="parentName"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-image>
                      }
                      @case ("tags") {
                        <snt-report-designer-tags
                          #renderer
                          [item]="templateItem"
                          [level]="level"
                          [parentName]="parentName"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-tags>
                      }
                      @case ("text") {
                        <snt-report-designer-text
                          #renderer
                          [item]="templateItem | asTextConfig"
                          [level]="level"
                          [parentName]="parentName"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-text>
                      }
                      @case ("textarea") {
                        <snt-report-designer-textarea
                          #renderer
                          [item]="templateItem | asTextConfig"
                          [level]="level"
                          [parentName]="parentName"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-textarea>
                      }
                      @case ("table") {
                        <snt-report-designer-table
                          #renderer
                          [item]="templateItem | asGridConfig"
                          [propertyDataSource]="tablePropertyDataSource"
                          [level]="level"
                          [parentName]="parentName"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-table>
                      }
                      @case ("customer-signature") {
                        <snt-report-designer-customer-signature
                          #renderer
                          [item]="templateItem"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-customer-signature>
                      }
                      @case ("signature") {
                        <snt-report-designer-signature
                          #renderer
                          [item]="templateItem"
                          [level]="level"
                          [parentName]="parentName"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-signature>
                      }
                      @case ("spacer") {
                        <snt-report-designer-spacer
                          #renderer
                          [item]="templateItem | asSpacerConfig"
                          [level]="level"
                          [parentName]="parentName"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-spacer>
                      }
                      @case ("title") {
                        <snt-report-designer-title
                          #renderer
                          [item]="templateItem | asTitleConfig"
                          [level]="level"
                          [parentName]="parentName"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-title>
                      }
                      @case ("checklist") {
                        <snt-report-designer-checklist
                          #renderer
                          [item]="templateItem | asTextConfig"
                          [level]="level"
                          [parentName]="parentName"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-checklist>
                      }
                      @case ("check") {
                        <snt-report-designer-check
                          #renderer
                          [item]="templateItem | asTextConfig"
                          [level]="level"
                          [parentName]="parentName"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-check>
                      }
                      @case ("selectbox") {
                        <snt-report-designer-selectbox
                          #renderer
                          [item]="templateItem | asSelectboxConfig"
                          [level]="level"
                          [parentName]="parentName"
                          [readonly]="readonly"
                          (config)="onConfigChanged(templateItem, $event)"
                        ></snt-report-designer-selectbox>
                      }
                      @case ("empty") {
                        <snt-report-designer-empty
                          #renderer
                          [item]="templateItem | asTextConfig"
                          [level]="level"
                          [parentName]="parentName"
                        ></snt-report-designer-empty>
                      }
                    }
                  </div>

                  @if (templateItem?.enableHideFeature) {
                    <div class="flex flex-row gap-2">
                      <span class="text-sm text-slate-500">
                        {{ "Nascondi" | transloco }}
                      </span>

                      <dx-switch
                        [disabled]="readonly"
                        [switchedOnText]="'Si' | transloco"
                        [switchedOffText]="'No' | transloco"
                        [value]="templateItem.config.hidden"
                        (valueChange)="
                          onEnableHideFeatureChange(templateItem, $event)
                        "
                      ></dx-switch>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }

      @if (!readonly) {
        <div
          class="
          {{ scrollable ? 'absolute inset-0' : '' }}
          m-2
          p-2
          flex flex-col
          gap-2
          items-center
          justify-center
          border-2 border-dashed rounded-md
          "
        >
          <i
            class="fa-light fa-rectangle-history-circle-plus text-2xl text-slate-400"
          ></i>

          <span class="text-xs text-slate-400">
            @if (groupTitle) {
              {{ "Trascina per aggiungere a" | transloco }} "{{ groupTitle }}"
            } @else {
              {{ "Trascina per aggiungere" | transloco }}
            }
          </span>
        </div>
      }
    </dx-draggable>
  </div>
</ng-template>
